import axios from "axios";
import { Response } from "@/shared/models/Response";
import { QuerySendMultiple } from "../../../shared/models/FormQuerySend";
import { DependencyPagination } from "../models/DependencyPaginatinaton";
import { Dependency } from "../models/Dependency";
import { DependencyAllData } from "../models/DependencyAllData";

export class DependenciesService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_SCHEDULING_API}/dependency`;
  }

  async findAll(): Promise<Response<DependencyAllData[]>> {
    const serviceURL = `${this.baseUrl}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getDependenciesWithFilters(
    filterQuery: QuerySendMultiple
  ): Promise<Response<DependencyPagination>> {
    const serviceURL = `${this.baseUrl}/filters`;
    const response = await axios.get(serviceURL, { params: filterQuery });
    return response.data;
  }

  async updateStateDependency(
    itemId: string,
    state: string
  ): Promise<Response<DependencyPagination>> {
    const serviceURL = `${this.baseUrl}/state/${itemId}/${state}`;
    const response = await axios.put(serviceURL);
    return response.data;
  }

  async deleteDependency(
    itemId: string
  ): Promise<Response<DependencyPagination>> {
    const serviceURL = `${this.baseUrl}/${itemId}`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }

  async getDependency(itemId: string): Promise<Response<Dependency>> {
    const serviceURL = `${this.baseUrl}/${itemId}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async createDependency(
    dependency: Dependency
  ): Promise<Response<Dependency>> {
    const serviceURL = `${this.baseUrl}/`;
    const response = await axios.post(serviceURL, { dependency: dependency });
    return response.data;
  }

  async updateDependency(
    itemId: string,
    dependency: Dependency
  ): Promise<Response<Dependency>> {
    const serviceURL = `${this.baseUrl}/${itemId}`;
    const response = await axios.put(serviceURL, { dependency: dependency });
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;
    const params = {
      params: {
        nameDependency: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
}
